export const cf7RandomizerForId = () => {
  document.addEventListener('wpcf7mailsent', function (event) {
    const formElement = event.target;
    console.log('should be generated random ID')

    const hiddenField = formElement.querySelector('[name="form_id"]');

    if (hiddenField) {
      // Generate a new unique ID
      const prefix = "CLX_";
      const uniqueId = prefix + Math.random().toString(36).substr(2, 9);

      hiddenField.value = uniqueId;
    }
  }, false);
}